import { initializeApp, getApps } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAT9B3RmnPjWlHN_4fwmgRMO5HqyoZMLiY",
  authDomain: "million-experts-job-portal.firebaseapp.com",
  projectId: "million-experts-job-portal",
  storageBucket: "gs://million-experts-job-portal.appspot.com",
  messagingSenderId: "84152319172",
  appId: "1:84152319172:web:fe11b49295f368966e5d91",
  measurementId: "G-Z4GP0MSC40",
  // Add Firestore configuration options
  databaseURL: "databaseURL",
  // Enable offline persistence
  persistence: true,
};

// Initialize Firebase
let firebase_app =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
export default firebase_app;
